"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferLetterTemplatesContract = void 0;
/* eslint-disable perfectionist/sort-objects */
const core_1 = require("@ts-rest/core");
const schemas_1 = require("../../../../schemas");
const offer_letters_request_1 = require("./offer-letters.request");
const offer_letters_response_1 = require("./offer-letters.response");
const c = (0, core_1.initContract)();
exports.OfferLetterTemplatesContract = c.router({
    create: {
        method: 'POST',
        path: '/',
        body: offer_letters_request_1.OfferLetterTemplateCreateRequestSchema,
        responses: {
            201: offer_letters_response_1.OfferLetterTemplateResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
        },
    },
    findMany: {
        method: 'GET',
        path: '/',
        query: offer_letters_request_1.OfferLetterTemplateListQuerySchema,
        responses: {
            200: offer_letters_response_1.OfferLetterTemplateListResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
        },
    },
    findById: {
        method: 'GET',
        path: '/:templateId',
        pathParams: offer_letters_request_1.OfferLetterTemplateIdPathParamsSchema,
        responses: {
            200: offer_letters_response_1.OfferLetterTemplateResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    update: {
        method: 'PATCH',
        path: '/:templateId',
        pathParams: offer_letters_request_1.OfferLetterTemplateIdPathParamsSchema,
        body: offer_letters_request_1.OfferLetterTemplateUpdateRequestSchema,
        responses: {
            200: offer_letters_response_1.OfferLetterTemplateResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    delete: {
        method: 'DELETE',
        path: '/:templateId',
        pathParams: offer_letters_request_1.OfferLetterTemplateIdPathParamsSchema,
        responses: {
            200: schemas_1.BaseResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
}, { pathPrefix: '/offer-letters' });
